export default __webpack_public_path__ + "static/media/mercadopago-logo.3f32c06f.svg";